import React from 'react'
import { Link } from 'react-router-dom'

const wrapperStyle = {
  minHeight: '60vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  padding: '24px'
}

const badgeStyle = {
  fontSize: '48px',
  fontWeight: 700,
  marginBottom: '12px',
  color: '#c53030'
}

const messageStyle = {
  maxWidth: '420px',
  marginBottom: '20px',
  lineHeight: 1.4
}

const linkStyle = {
  display: 'inline-block',
  padding: '10px 18px',
  borderRadius: '6px',
  backgroundColor: '#2563eb',
  color: '#fff',
  textDecoration: 'none'
}

const RestrictedView = ({ title = '404', description = 'La pagina solicitada no existe o no cuenta con permisos para verla.' }) => (
  <div className="restricted-view" style={wrapperStyle}>
    <div style={badgeStyle}>{title}</div>
    <p style={messageStyle}>{description}</p>
    <Link to="/inicio" style={linkStyle}>
      Ir al inicio
    </Link>
  </div>
)

export default RestrictedView
